import Layout from 'lib/czqui/layout'
import CZQInput from 'lib/czqui/input/CZQInput'
import CZQSelect from 'lib/czqui/select/CZQSelect'
import KeyboardUtils from 'lib/czqui/util/KeyboardUtils.js'
import popupListService from 'lib/czqui/popup-list/service.js'

export default function (Vue, options = {}) {
	Vue.mixin(Layout)
	Vue.component('czq-input', CZQInput)
	Vue.component('czq-select', CZQSelect)
	Vue.prototype['$czqPopupList'] = popupListService
	KeyboardUtils.fixKeyboard()
	KeyboardUtils.fixInputboard()
}



// WEBPACK FOOTER //
// ./src/lib/czqui/index.js